<template>
  <div class="container">
    <img class="banner" src="../../../assets/img/guide/traceless.png" />
    <div class="content">
      <h3 class="subTitle">如何使用？</h3>
      <div class="progress">
        <div>
          <span class="no">1</span>
          <span class="des">选择文件</span>
        </div>
        <div class="dottedCon">
          <span class="dotted" />
        </div>
        <div>
          <span class="no">2</span>
          <span class="des">开启无痕打印</span>
        </div>
        <div class="dottedCon">
          <span class="dotted" />
        </div>
        <div>
          <span class="no">3</span>
          <span class="des">开始打印</span>
        </div>
      </div>
      <h3 class="subTitle">无痕打印和正常打印的区别？</h3>
      <p class="text">
        正常打印时，会自动为您备份打印文件在云端，防止文件丢失，再次需要打印时。可通过福昕云文档找到。可通过微信搜索【福昕云文档】小程序，或使用浏览器打开网站:https://docs.foxitcloud.cn来登录福昕云文档。
      </p>
      <p class="text">
        开启无痕打印模式，打印文件不会备份存储在云端，打印结束后，自动删除打印文件，安全可靠，打印无优。
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.container {
  max-width: 750px;
  width: 100%;
  margin: 0 auto;
}

.banner {
  width: 100%;
  height: 300px;
}

.content {
  width: 100%;
  padding: 55px;
}

.progress {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 20px 0 40px;
  & > div {
    display: flex;
    align-items: center;
  }
  .no {
    display: block;
    width: 32px;
    height: 32px;
    background-color: #0078ff;
    border-radius: 16px;
    color: white;
    font-size: 24px;
    margin-right: 18px;
    text-align: center;
    line-height: 32px;
  }
  .des {
    font-size: 28px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 28px;
    letter-spacing: 1px;
    color: #666666;
  }
  .dottedCon {
    padding: 4px 0 4px 15px;
    .dotted {
      height: 29px;
      border-left: 1px dotted #0078ff;
    }
  }
}

.subTitle {
  font-size: 32px;
  font-stretch: normal;
  line-height: 51px;
  letter-spacing: 2px;
  color: #333333;
  font-weight: bold;
}

.text {
  font-family: MicrosoftYaHei;
  font-size: 28px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 68px;
  letter-spacing: 1px;
  color: #666666;
}
</style>
